export default __webpack_public_path__ + "static/media/red-dot.5cf1029e.svg";